/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeviceStatus,
    DeviceStatusFromJSON,
    DeviceStatusFromJSONTyped,
    DeviceStatusToJSON,
} from './DeviceStatus';
import {
    ReportForDeviceLastConnectionElementResponse,
    ReportForDeviceLastConnectionElementResponseFromJSON,
    ReportForDeviceLastConnectionElementResponseFromJSONTyped,
    ReportForDeviceLastConnectionElementResponseToJSON,
} from './ReportForDeviceLastConnectionElementResponse';

/**
 * 
 * @export
 * @interface ReportForDeviceResponseDeviceLastConnectionElement
 */
export interface ReportForDeviceResponseDeviceLastConnectionElement {
    /**
     * 
     * @type {Date}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    lastConnectedAt: Date | null;
    /**
     * 
     * @type {DeviceStatus}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    lastConnectedStatus: DeviceStatus;
    /**
     * 
     * @type {ReportForDeviceLastConnectionElementResponse}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    loader: ReportForDeviceLastConnectionElementResponse;
    /**
     * 
     * @type {ReportForDeviceLastConnectionElementResponse}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    firmware: ReportForDeviceLastConnectionElementResponse;
    /**
     * 
     * @type {ReportForDeviceLastConnectionElementResponse}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    ui: ReportForDeviceLastConnectionElementResponse;
    /**
     * 
     * @type {ReportForDeviceLastConnectionElementResponse}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    customFirmware1: ReportForDeviceLastConnectionElementResponse;
    /**
     * 
     * @type {ReportForDeviceLastConnectionElementResponse}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    customFirmware2: ReportForDeviceLastConnectionElementResponse;
    /**
     * 
     * @type {ReportForDeviceLastConnectionElementResponse}
     * @memberof ReportForDeviceResponseDeviceLastConnectionElement
     */
    customFirmware3: ReportForDeviceLastConnectionElementResponse;
}

export function ReportForDeviceResponseDeviceLastConnectionElementFromJSON(json: any): ReportForDeviceResponseDeviceLastConnectionElement {
    return ReportForDeviceResponseDeviceLastConnectionElementFromJSONTyped(json, false);
}

export function ReportForDeviceResponseDeviceLastConnectionElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeviceResponseDeviceLastConnectionElement {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lastConnectedAt': (json['lastConnectedAt'] === null ? null : new Date(json['lastConnectedAt'])),
        'lastConnectedStatus': DeviceStatusFromJSON(json['lastConnectedStatus']),
        'loader': ReportForDeviceLastConnectionElementResponseFromJSON(json['loader']),
        'firmware': ReportForDeviceLastConnectionElementResponseFromJSON(json['firmware']),
        'ui': ReportForDeviceLastConnectionElementResponseFromJSON(json['ui']),
        'customFirmware1': ReportForDeviceLastConnectionElementResponseFromJSON(json['customFirmware1']),
        'customFirmware2': ReportForDeviceLastConnectionElementResponseFromJSON(json['customFirmware2']),
        'customFirmware3': ReportForDeviceLastConnectionElementResponseFromJSON(json['customFirmware3']),
    };
}

export function ReportForDeviceResponseDeviceLastConnectionElementToJSON(value?: ReportForDeviceResponseDeviceLastConnectionElement | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lastConnectedAt': (value.lastConnectedAt === null ? null : value.lastConnectedAt.toISOString()),
        'lastConnectedStatus': DeviceStatusToJSON(value.lastConnectedStatus),
        'loader': ReportForDeviceLastConnectionElementResponseToJSON(value.loader),
        'firmware': ReportForDeviceLastConnectionElementResponseToJSON(value.firmware),
        'ui': ReportForDeviceLastConnectionElementResponseToJSON(value.ui),
        'customFirmware1': ReportForDeviceLastConnectionElementResponseToJSON(value.customFirmware1),
        'customFirmware2': ReportForDeviceLastConnectionElementResponseToJSON(value.customFirmware2),
        'customFirmware3': ReportForDeviceLastConnectionElementResponseToJSON(value.customFirmware3),
    };
}

